'use client';

import ServiceContent from '@/components/services/ServiceContent';
import AuctionAccessContent from '@/content/services/en/auction-access.mdx';

export default function AuctionAccessClient() {
    return (
        <ServiceContent>
            <AuctionAccessContent />
        </ServiceContent>
    );
}
